import store from '../../store/Store'

export const getWidgetMapping = (widgetName: string) => {
  const state = store?.getState()
  const widgetIdMapping = state?.atlas?.widgetIdMapping
  if (widgetIdMapping && widgetIdMapping[widgetName]) {
    return widgetIdMapping[widgetName]
  }
  return ''
}
export const isAuthorized = (widgetName: string) => {
  const state = store?.getState()
  const permissionList = state?.atlas?.permissionList
  return permissionList?.includes(getWidgetMapping(widgetName))
}
